// extracted by mini-css-extract-plugin
export default {"linkHover":"Navbar_linkHover__NZZQ+","navBgColor":"Navbar_navBgColor__H2ahQ","logoSize":"Navbar_logoSize__tlO8X"};